import SubscribeTodayDisclaimer from './SubscribeTodayDisclaimer';

export default SubscribeTodayDisclaimer;
